import * as React from 'react';

import MainStore from '@src/pages/main/store';
import Page from '../../components/page';
import wrapStore from '@src/utils/wrap-store';
import createLazyComponent from '@src/utils/create-lazy-component';
import PageSwiper from '@src/components/swiper/page-swiper';
import cx from 'classnames';
import ScrollTip from '@src/business-components/scroll-tip';
import FirstPage from '@src/pages/main/components/first-page';
import Footer from '@src/business-components/backtop-footer/components/footer';

const styles = require('./index.less');

const ThirdPageLazy = createLazyComponent(() => import('@src/pages/main/components/third-page'));
const FourthPageLazy = createLazyComponent(() => import('@src/pages/main/components/fourth-page'));
const FifthPageLazy = createLazyComponent(() => import('@src/pages/main/components/fifth-page'));
const SixthPageLazy = createLazyComponent(() => import('@src/pages/main/components/sixth-page'));
const SeventhPageLazy = createLazyComponent(() => import('@src/pages/main/components/seventh-page'));

/**
 * Main
 * @param store {MainStore}
 * @returns {JSX.Element}
 * @constructor
 */
const Main = ({ store }) => {
  store.use();
  return (
    <Page className={cx(styles.root, 'main-page-root')}>
      <PageSwiper store={store.pageSwiperStore}>
        <div className={styles.pageItem}>
          <FirstPage store={store.firstPageStore} />
        </div>
        <div className={styles.pageItem}>{<ThirdPageLazy store={store.newsStore} />}</div>
        <div className={styles.pageItem}>{<FourthPageLazy store={store.mechaListStore} />}</div>
        <div className={styles.pageItem}>
          {store.isRenderFifthPage && <FifthPageLazy store={store.specialMechaStore} isActive={store.pageSwiperStore?.baseSwiperStore?.activeIndex === 3} />}
        </div>
        <div className={styles.pageItem}>{<SixthPageLazy store={store.featureListStore} />}</div>
        <div className={styles.pageItem}>{<SeventhPageLazy store={store.worldViewStore} />}</div>
      </PageSwiper>

      <div className={cx(styles.footer, { [styles.isActive]: store.isFooterActive })}>
        <Footer store={store.footerStore} />
      </div>
      <ScrollTip store={store.scrollTipStore} />
    </Page>
  );
};

export default wrapStore(Main, MainStore);
